/*
* Copyright (c) 2014-2023 Inovalon, Inc. All Rights Reserved.
* This computer program is CONFIDENTIAL and a TRADE SECRET of Inovalon, Inc.
* The receipt or possession of this program does not convey any rights to use, reproduce or disclose
* its contents in whole or in part, without the specific written consent of Inovalon, Inc.
* Any use, reproduction or disclosure of this program without the express written consent of Inovalon, Inc.
* is a violation of the copyright laws and may subject you to criminal prosecution.
*/
import { ICoverageDiscoveryBatchRequest, IBatchExcelUploadResponse, ICoverageDiscoveryBatchImportGrid, ICoverageDiscoveryBatchImportGridResults, IContinueBatchUpload } from '../ImportBatchUIStateManager/contracts'
import { IImportBatchUIApiClient } from './contracts'
import { injectable } from 'inversify'

@injectable()
export class MockImportBatchUIApiClient implements IImportBatchUIApiClient {
	public items: ICoverageDiscoveryBatchImportGrid[] = []
	public response: IBatchExcelUploadResponse | undefined
	public gridResults: ICoverageDiscoveryBatchImportGridResults | undefined

	constructor() {
		for (let x = 1; x <= 40; x++) {
			this.items.push({
				rowNumber: x,
				responseInformation: `Informationetethhyhyrhyrjryjtujtujtujjutuuuuuuuuu ${x}`,
				errorMessage: `Errorutjujuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuu ${x}`,
			})
		}
		this.gridResults = {
			coverageDiscoveryBatchResponseGridErrorResultCollection: this.items,
			errorCount: 40,
		}
		this.response = {
			successfulRowsCount: 5,
			erroroneousRowsCount: 4,
			erroroneousRows: [],
			successfulRows: [],
			fileName: 'testfile',
			batchName: 'testbatch',
			metaDataHeaders: [],
			coverageDiscoveryBatchResponseGridErrorResultList: this.gridResults,
		}
	}

	saveItem(coverageDiscoveryBatchRequest: ICoverageDiscoveryBatchRequest): Promise<IBatchExcelUploadResponse> {
		return new Promise<IBatchExcelUploadResponse>(resolve => {
			setTimeout(() => resolve(this.response), 100)
		})
	}

	sendSuccessfulRowsData(item: IContinueBatchUpload) {
		return new Promise<void>(resolve => {
			setTimeout(() => resolve(), 100)
		})
	}
}
